class AssistantKnowledge {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/knowledge-categories`;

  }

  createKnowledgeCategory(data) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, data);

  }

  getKnowledgeCategories() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  deleteKnowledgeCategory(categoryId) {

    const path = `${this.basePath}/:categoryId`;

    return this.apiClient.delete(path, { categoryId });

  }

  getResourcesByCategoryId(categoryId, queryOptions) {

    const path = `${this.basePath}/:categoryId/resources`;

    return this.apiClient.get(path, { categoryId }, queryOptions);

  }

  createResource(categoryId, resource) {

    const path = `${this.basePath}/:categoryId/resources`;

    return this.apiClient.post(path, { categoryId }, {}, resource);

  }

  createResourceFile(categoryId, file) {

    const path = `${this.basePath}/:categoryId/files`;

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true, false);

  }

  updateResourceFile(categoryId, resourceId, file) {

    const path = `${this.basePath}/:categoryId/resources/:resourceId/file`;

    return this.apiClient.put(path, { categoryId, resourceId }, {}, file);

  }

  deleteResource(categoryId, resourceId) {

    const path = `${this.basePath}/:categoryId/resources/:resourceId`;

    return this.apiClient.delete(path, { categoryId, resourceId });

  }

  searchResources(queryOptions) {

    const path = `${this.basePath}/resources/search`;

    return this.apiClient.get(path, {}, queryOptions);

  }

}

export default AssistantKnowledge;